define('KeepSessionActive.EntryPoint', [
  'KeepSessionActive.EntrySS2Model'
], function (
  KeepSessionActiveEntrySS2Model
) {
  'use strict';

  return {
    mountToApp: function (container) {
      var environment = container.getComponent('Environment');
      var userProfileComponent = container.getComponent('UserProfile');
      var layout = container.getComponent('Layout');
      var sessionModel = new KeepSessionActiveEntrySS2Model();
      var sessionKey = 'sessionStart';
      var sessionStart = '';
      var minutes = environment.getConfig('keepSessionActiveTab.timeOfRequest');
      var hours = environment.getConfig('keepSessionActiveTab.timeExtended');
      var turnOff = environment.getConfig('keepSessionActiveTab.turnOff');
      var keepAliveIntervalMs = parseInt(minutes) * 60 * 1000;
      var timeInMs = hours === '0' ? 0 : parseInt(hours) * 60 * 60 * 1000;
      var sessionIntervalId = null;
      var self = this;

      if (userProfileComponent) {
        layout.on('afterShowContent', function () {
          if (self.isLoggedIn) {
            localStorage.setItem(sessionKey, Date.now());
          }
        });

        userProfileComponent.getUserProfile().then(function (profile) {
          if (profile && profile.isloggedin) {
            self.isLoggedIn = true;
            sessionIntervalId = setInterval(function () {
              sessionStart = localStorage.getItem(sessionKey);
              if (turnOff || sessionStart && Date.now() - parseInt(sessionStart, 10) > timeInMs) {
                localStorage.removeItem(sessionKey);
                clearInterval(sessionIntervalId);
              } else {
                sessionModel.fetch({
                  data: { action: 'active' }
                });
              }
            }, keepAliveIntervalMs);
          }
        });
      }

      return sessionIntervalId;
    }
  };
});
